import CopyShare from './CopyShare';

export default CopyShare;
